import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/authentication";
import business from './modules/store';
import search from './modules/search';
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

const store = new Vuex.Store({
    modules: {
        auth,
        business,
        search
    },
    plugins:[createPersistedState()],
    strict: debug
});

export default store;  